"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWopi = void 0;
const default_content_types_1 = require("@sensenet/default-content-types");
const react_1 = require("react");
const use_repository_1 = require("./use-repository");
/**
 * Returns two functions that can determine if the current content can be opened in WOPI for read or write.
 * In order to work this correctly, you need to get Actions field in the content.
 */
const useWopi = () => {
    const repo = use_repository_1.useRepository();
    const isWriteAvailable = react_1.useCallback((content) => repo.schemas.isContentFromType(content, 'File') &&
        default_content_types_1.isActionModel(content.Actions) &&
        content.Actions.some((action) => action.Name === 'WopiOpenEdit' && !action.Forbidden), [repo.schemas]);
    const isReadAvailable = react_1.useCallback((content) => isWriteAvailable(content) ||
        (repo.schemas.isContentFromType(content, 'File') &&
            default_content_types_1.isActionModel(content.Actions) &&
            content.Actions.some((action) => action.Name === 'WopiOpenView' && !action.Forbidden)), [isWriteAvailable, repo.schemas]);
    return {
        /**
         * The file can be opened for read with WOPI
         */
        isReadAvailable,
        /**
         * The file can be opened for write with WOPI
         */
        isWriteAvailable,
    };
};
exports.useWopi = useWopi;
//# sourceMappingURL=use-wopi.js.map